import * as ol from 'openlayers'
import BaseAspect from './BaseAspect.js'
import { translate } from '@/translation/native_translate.js';

export default class BaseRadiusPointAspect extends BaseAspect {

  constructor(data) {
    super(data);

    this.setProperties(data);
    this.style = [
      new ol.style.Style({
        image: new ol.style.Circle({
          radius: 20,
          fill: new ol.style.Fill({
            color: 'rgba(255, 255, 0, 0.63)'
          })
        })
      })
    ];

    this.warningMessage = 'WARNING_MESSAGE';
    this.warningTitle = 'WARNING_MESSAGE_TITLE';

    this.setZIndex(5);
  }


  setProperties(data) {
    super.setProperties(data);
    this.set('geometry', new ol.geom.GeometryCollection([new ol.geom.Point(ol.proj.transform(data.position, 'EPSG:4326', 'EPSG:3857'))]));
    if (data.hasOwnProperty('type')) {
      this.set('type', data.type);
    } else {
      this.set('type', 'BasePointAspect');
    }
  }

  createStyle() {
    return this.style;
  }
  
  getGpsPosition() {
    let convertedPosition = ol.proj.transform(this.get('geometry').getCoordinates(), 'EPSG:3857', 'EPSG:4326');
    return convertedPosition;
  }

  rightClick(pixel, gps, rightClickBehaviour = 0) {
    let forwardBehave = true;
    switch (rightClickBehaviour) {
      case 0: //normal behaviour

        break;
      case 1: //Relation creation
        forwardBehave = false;

        break;
    }

    if (forwardBehave) {
    }
  }

  removeObject() {
    window.Event.vue.$confirm(translate(this.warningMessage), translate(this.warningTitle), {
      confirmButtonText: translate('YES'),
      cancelButtonText: translate('NO'),
      type: 'warning'
    }).then(() => {
      var requestObject = {
        "childId": {
          "datatype": "string",
          "value": this.getId(),
        },
        "cleanDatabase": {
          "datatype": "bool",
          "value": true,
        }
      };

      if (this.get('parentId') === 'undefined') {
        this.$notify.error({
          title: "DESTINATION_OBJECT_FAILS_TO_REMOVE",
          message: "ERROR",
          duration: 0
        });
      } else {
        this.setLastAction('removeObject');
        const request = dssUtility.createDSSRequest(this.get('parentId'), "cleanupChild", requestObject);
        window.socket.sendMessage(request, () => {
          window.Event.vue.$notify.success({
            title: "DESTINATION_OBJECT_REMOVED",
            message: "Success"
          });
        });
      }
    });
  }
}
